import { render } from "./TitledText.vue?vue&type=template&id=0506b561"
import script from "./TitledText.vue?vue&type=script&lang=js"
export * from "./TitledText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__